import type { FaireProductEntity } from "../../entity_types/product";

export const p_emztjpv97t: FaireProductEntity = {
  token: "p_emztjpv97t",
  type: "product",
  name: "Cloud Little Notes®",
  brandToken: "b_de884c62",
  brandName: "E. Frances Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/9d7680c71f605b2eaeaf53941ee75d326bf05f5036f435b4a0909f22449f89b4.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2bf707bee36881d1d785a6eefcaef455ae62d10d323b2963298104a012d68550.jpeg",
    "https://cdn.faire.com/fastly/475b4133770864bc9f77cd7050cd4393bfdaa8d752ca18ebd6493e1b12c75403.jpeg",
    "https://cdn.faire.com/fastly/cbc38488b75135c7a37c42ce525fde6118db7e8a421fe7a684db4165ebd093d5.jpeg",
    "https://cdn.faire.com/fastly/27fc7237698e9377f181757441a8a76edd26c06d08016b2bb12f8fbfaa8323df.webp",
  ],
  priceDollars: 7,
  description:
    "Little Notes® are tiny in size and big on heart. Small enough to slip in a pocket, a lunch box, or a stack of books, each one carries something much larger than its size: a laugh, a love note, a reminder that someone is seen. Whether it’s a joke tucked into a backpack, a to-do list turned sweet, or a simple “thank you,” Little Notes bring joy to life’s little, big and in-between moments.\n\nEvery Little Note features hand-painted watercolor illustrations, front and back, so even the simplest message feels special. With 55 per pack, you can mix, match and share freely. Over 69 million Little Notes have already been shared worldwide, sparking connection one small gesture at a time.",
  tags: [],
  msrpDollars: 14,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-06-21T23:36:28.117Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
